import { render, staticRenderFns } from "./Historique.vue?vue&type=template&id=f855b778&scoped=true"
import script from "./Historique.vue?vue&type=script&lang=ts"
export * from "./Historique.vue?vue&type=script&lang=ts"
import style0 from "./Historique.vue?vue&type=style&index=0&id=f855b778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f855b778",
  null
  
)

export default component.exports